import { render, staticRenderFns } from "./import_customer.vue?vue&type=template&id=ceeb3876"
import script from "./import_customer.vue?vue&type=script&lang=js"
export * from "./import_customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports